export const messages = Object.freeze({
    archived_space: 'This space is archived.',
    broken_link: 'This link is broken or no longer valid.',
    data_not_found: 'The template source does not contain loadable data.',
    deleted_bundle: 'This assignment has been deleted.',
    incorrect_snapshot_ordering: 'The snapshots are in the wrong order.',
    instance_deleted: 'The instance has been deleted.',
    invalid_snapshot_location: 'Invalid snapshot location. Please check your input and try again.',
    multi_target_distribute_forbidden: "You don't have permission to perform this action.",
    restic_migration_already_in_progress: 'The snapshot backup operation could not be completed. Please contact support.',
    restic_migration_in_progress: 'One or more spaces in this org are having backup repositories migrated. Please try again shortly.',
    snapshot_deleted: 'The snapshot has been deleted.',
    snapshot_missing: 'The snapshot is missing or could not be found.',
    snapshot_not_development: 'The snapshot is not development.',
    space_not_found: 'The requested space could not be found.',
    space_resting_state: 'This space is resting. Please activate it first.',
    unidentifiable_space_request: 'The request could not be processed because a required identifier is missing.'
})

export const dialogs = Object.freeze({})
